import { Page } from 'components/common';
import HeaderSEO from 'components/HeaderSEO';
import { GiftCardContent } from 'lib/gift-card';
import React from 'react';

const GiftCards = () => {
  return (
    <Page
      content={
        <React.Fragment>
          <HeaderSEO
            title="Give a Priceless Gift of a Healthy Diet with $50 Yummy Bros Gift Cards!"
            description="In our not-so-humble opinion, an enjoyable healthy diet is hands-down the best gift you can give! So, Solve your gifting woes by grabbing a bunch of Yummy Bros Gift Cards!"
            path="https://www.yummybros.com/giftcards"
            image="https://yb-production.s3.ap-southeast-1.amazonaws.com/images/static/gift-cards-meta-image.jpg"
            ogType="article"
          />

          <GiftCardContent />
        </React.Fragment>
      }
    />
  );
};

export default GiftCards;
